import type { MicrophonePermissionCopy } from '@/i18n/microphone-permission-copy';

export function isMicrophonePermissionError(error: unknown): boolean {
  return (
    !!error &&
    typeof error === 'object' &&
    'name' in error &&
    (error.name === 'NotAllowedError' ||
      error.name === 'PermissionDeniedError' ||
      error.name === 'SecurityError')
  );
}

export function microphonePermissionErrorMessage(
  error: unknown,
  copy: MicrophonePermissionCopy,
  desktop: boolean
): string | null {
  if (!isMicrophonePermissionError(error)) return null;
  return desktop ? copy.deniedDescription : copy.webDeniedDescription;
}
